import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
// eslint-disable-next-line import/no-extraneous-dependencies
// import { Img } from "@sunwing/shared-components";
// eslint-disable-next-line import/no-cycle
import { Card } from "../../../../sharedComponents/Card";
// eslint-disable-next-line import/no-cycle
import { LogoPositions } from "../CardBuilder";
import * as styles from "./CardLogo.module.scss";

const CardLogo = ({ className, logo, logoPosition }) => (
	<>
		{logo && (
			<div className={cx(styles.logoContainer, className, styles[logoPosition || "topLeft"])}>
				<Card.Image
					className={cx(styles.logo)}
					fluid={logo?.fluid}
					src={logo?.src || logo.secure_url}
					source={logo?.srcSet && logo}
					alt={logo?.alt}
				/>
				{/* <Img
					wrapperClassName={styles.logo}
					fluid={logo?.fluid}
					src={logo?.src || logo.secure_url}
					source={logo?.srcSet && logo}
					alt={logo?.alt}
					autoResponsive={false}
					// eslint-disable-next-line react/jsx-props-no-spreading
					{...imageComponentProps}
				/> */}
			</div>
		)}
	</>
);

CardLogo.propTypes = {
	className: PropTypes.string,
	logo: PropTypes.object,
	logoPosition: PropTypes.oneOf(Object.values(LogoPositions)),
	// imageComponentProps: PropTypes.object,
};

CardLogo.defaultProps = {
	className: "",
	logo: undefined,
	logoPosition: undefined,
	// imageComponentProps: {},
};

export default CardLogo;
export { CardLogo };
